import type { GroupTimeSeriesPoint } from '@/types/reports';

export interface CompareDollars {
  /** Solar savings: the RPC's costSaved (each unit-day at its configured import rate). */
  solarSavings: number;
  /** Same as solarSavings (kept for the existing Net Savings row). */
  netSavings: number;
  /** Grid import cost: the RPC's gridCost, or null when the RPC has none yet. */
  gridCost: number | null;
  gridSellRevenue: number;
  /** Savings + sell revenue - grid cost; null when grid cost is. */
  totalValue: number | null;
}

/**
 * Dollar totals for a compare slot, priced by the energy RPC exactly like the
 * dashboard and the Excel export (audit F03). When any period lacks gridCost
 * (a database before migration 20261027230000), grid cost and total value are
 * null and shown as "—", the same rule as the export's N/A: never a guessed rate.
 */
export function sumCompareDollars(points: GroupTimeSeriesPoint[]): CompareDollars {
  let solarSavings = 0;
  let gridSellRevenue = 0;
  let gridCost = 0;
  let allHaveGridCost = true;
  for (const p of points) {
    solarSavings += p.costSaved || 0;
    gridSellRevenue += p.gridSellRevenue || 0;
    if (typeof p.gridCost === 'number' && Number.isFinite(p.gridCost)) gridCost += p.gridCost;
    else allHaveGridCost = false;
  }
  const knownGridCost = allHaveGridCost ? gridCost : null;
  return {
    solarSavings,
    netSavings: solarSavings,
    gridCost: knownGridCost,
    gridSellRevenue,
    totalValue: knownGridCost === null ? null : solarSavings + gridSellRevenue - knownGridCost,
  };
}
